module.exports = __webpack_public_path__ + "img/opportunities.6d5304d7.svg";